/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, March 21st 2023, 5:52:50 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { APIMakeRequestFncArgs, APISERVICEPATHS, useAPIForm } from "lib/api";
import { ProcessTemplateCategory, ProcessTemplateCategoryValidationSchema } from "lib/schemas";
import { getDefaultProcessCategory } from "lib/factories";

interface UseProcessCategoryAPIFormArgs {
  categoryId: ProcessTemplateCategory["id"];
  organizationId: ProcessTemplateCategory["artifact_org"];
  site: ProcessTemplateCategory["site"];
  handleAPIResponse: APIMakeRequestFncArgs<ProcessTemplateCategory>["setValidAPIResponse"];
}
const useProcessCategoryAPIForm = (args: UseProcessCategoryAPIFormArgs) => {
  const { categoryId, handleAPIResponse, organizationId, site } = args;
  const useAPIFormReturn = useAPIForm({
    apiInitialFetchId: categoryId,
    apiFormDefaultValues: getDefaultProcessCategory({ organizationId, site }),
    apiFormDataValidationSchema: ProcessTemplateCategoryValidationSchema,
    apiServicePath: APISERVICEPATHS.processTemplateCategories,
    setAPIFormResponse: handleAPIResponse,
    primaryKey: "id",
    titleKey: "title",
  });

  return {
    useAPIFormReturn,
  };
};

export const useProcessCategoryAPI = () => ({
  useProcessCategoryAPIForm,
});
